import { FaFacebook, FaTwitter, FaInstagram, FaGithub, FaLinkedin, FaTiktok } from 'react-icons/fa';
import classNames from 'classnames/bind';

import styles from './Footer.module.scss';
import { useContext, useEffect, useState } from 'react';
import Img from '../Img';
import images from '~/assets';
import { ThemeModeContext } from '../Context/ThemeModeProvider';
import { useDarkMode } from '~/hooks/useDarkMode';

const cx = classNames.bind(styles);

const Footer = () => {
  const { theme } = useContext(ThemeModeContext);
  const [isDarkMode, setIsDarkMode] = useState(useDarkMode());

  useEffect(() => {
    setIsDarkMode(theme === 'dark' ? true : false);
  }, [theme]);

  return (
    <footer className={cx('footer')}>
      <div className={cx('container')}>
        {/* Cột 1: Mô tả */}
        <div className={cx('column')}>
          <h3>Blog của Ngô Gia Quyến</h3>
          <p>Nơi chia sẻ kiến thức về lập trình, công nghệ, và nhiều hơn thế.</p>
          <div className={cx('tai-tro')}>
            {isDarkMode ? (
              <Img src={images.vnnicLogo} className={cx('vnnic')} />
            ) : (
              <Img src={images.vnnicLogo2} className={cx('vnnic')} />
            )}
            <Img src="https://ngogiaquyen.id.vn/assets/ictu/logo.png" />
            <images.tenten />
          </div>
        </div>

        {/* Cột 2: Liên kết nhanh */}
        <div className={cx('column', 'fast-link')}>
          <h3>Trang web khác của tôi</h3>
          <ul className={cx('navLinks')}>
            <li>
              <a href="https://ngogiaquyen.io.vn/" target='blank'>Website học tiếng trung</a>
            </li>
            <li>
              <a href="https://send-email-1-p3qx.onrender.com/">Website đánh giá</a>
            </li>
            {/* <li>
              <a href="/contact">Viết bài cùng tôi</a>
            </li>
            <li>
              <a href="/privacy">Góp ý & đề xuất chủ đề</a>
            </li> */}
          </ul>
        </div>

        {/* Cột 3: Liên hệ */}
        <div className={cx('column', 'contact')}>
          <h3>Liên hệ</h3>
          <p>📍 Địa chỉ: TP Thái Nguyên, Thái Nguyên</p>
          <p>📧 Email: ngogiaquyendhtn223@gmail.com</p>
          <p>📞 Điện thoại: 0356197132</p>
        </div>

        {/* Cột 4: Mạng xã hội */}
        <div className={cx('column', 'socialIcons')}>
          <h3>Kết nối với tôi</h3>
          <div className={cx('icons')}>
            <a href="https://www.facebook.com/share/165jkkeQ9a/?mibextid=wwXIfr" target="_blank">
              <FaFacebook />
            </a>
            <a href="https://github.com/ngogiaquyen" target="_blank">
              <FaGithub />
            </a>
            <a href="https://www.linkedin.com/in/quyen-ngo-gia" target="_blank">
              <FaLinkedin />
            </a>
            <a href="https://www.tiktok.com/@qngok4" target="_blank">
              <FaTiktok />
            </a>
          </div>
        </div>
      </div>

      {/* Bản quyền */}
      <p className={cx('copyright')}>
        &copy; {new Date().getFullYear()} Blog của Ngô Gia Quyến. Mọi quyền được bảo lưu.
      </p>
    </footer>
  );
};

export default Footer;